module.exports = __webpack_public_path__ + "img/back-ground.6d84275f.png";